// components
import { ModuleLayout } from '@/components/reusable_components/next'

// views
import AccAccountingSeatConceptCreateView from '@/views/Accounting/AccAccountingSeatConcept/create'
import AccAccountingSeatConceptListView from '@/views/Accounting/AccAccountingSeatConcept/list'
import AccAccountingSeatConceptUpdateView from '@/views/Accounting/AccAccountingSeatConcept/update'

// routes
export default {
  path: 'acc_accounting_seat_concept',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'acc-accounting-seat-concept-list',
      component: AccAccountingSeatConceptListView,
    },
    {
      path: 'create',
      name: 'acc-accounting-seat-concept-create',
      component: AccAccountingSeatConceptCreateView,
    },
    {
      path: 'update',
      name: 'acc-accounting-seat-concept-update',
      component: AccAccountingSeatConceptUpdateView,
    },
  ],
  meta: {
    group: 'Contabilidad',
    title: 'Conceptos',
  },
}
